export class PushCartGiftingUpdate extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    const recipientInput = this.form.querySelector(
      '[name="properties[Recipient name]"]',
    )
    const customerInput = this.form.querySelector(
      '[name="properties[Customer name]"]',
    )

    const alphanumericOnly = (e) => {
      e.target.value = e.target.value.replace(
        /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
        '',
      )
    }

    if (recipientInput) {
      this.listeners.add(recipientInput, 'input', alphanumericOnly)
    }
    if (customerInput) {
      this.listeners.add(customerInput, 'input', alphanumericOnly)
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  containsEmoji (str) {
    return /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u.test(str)
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.updateProperties()
  }

  async updateProperties () {
    const formData = new FormData(this.form)

    const recipientName = formData.get('properties[Recipient name]') || ''
    const customerName = formData.get('properties[Customer name]') || ''
    const giftMessage = formData.get('properties[Gift message]') || ''

    if (this.containsEmoji(giftMessage)) {
      this.showError('Emojis are not allowed.')
      return
    }

    this.showError('')

    const itemProperties = {
      'Recipient name': recipientName,
      'Customer name': customerName,
      'Gift message': giftMessage,
    }

    await window.BAO.Cart.updateItemProperties(
      this.dataset.itemKey,
      1,
      itemProperties,
    )
  }

  showError (message) {
    let errorEl = this.querySelector('.gift-message-error')

    if (!errorEl) {
      errorEl = document.createElement('div')
      errorEl.className = 'gift-message-error'
      errorEl.style.color = 'red'
      errorEl.style.fontSize = '14px'
      errorEl.style.marginTop = '4px'

      const input = this.form.querySelector(
        '[name="properties[Gift message]"]',
      )
      if (input) input.insertAdjacentElement('afterend', errorEl)
    }

    errorEl.textContent = message
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

if (!customElements.get('push-cart-gifting-update')) {
  customElements.define('push-cart-gifting-update', PushCartGiftingUpdate)
}
